import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-index",
  "use": "icon-menu-index-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18 18\" id=\"icon-menu-index\">\r\n<path id=\"icon-menu-index_XMLID_402_\" d=\"M8.9,0.7L0,9.7h2.3v6.7c0,0.6,0.5,1.1,1.1,1.1h2.3c0.6,0,1.1-0.5,1.1-1.1V12h4.5v4.5\r\n\tc0,0.6,0.5,1.1,1.1,1.1h2.3c0.6,0,1.1-0.5,1.1-1.1V9.7H18L8.9,0.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol